module.exports = __webpack_public_path__ + "media/images/logo_digitalwerk-a83a2e20522cef7d7786c4e37cc4f035.svg";